import {
  Box,
  Flex,
  Spinner,
  Stack,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Header } from '../../../components/Header'
import { Sidebar } from '../../../components/Sidebar'

import { CardContainer } from '../../../components/molecules/CardContainer'

import WhatsappConnect from '../../../components/WhatsappConnection'

export default function ConnectionsScreen() {
  const [t] = useTranslation("pageConnections")
  const [isLoading, setIsLoading] = useState(true)
  const isWideVersion = useBreakpointValue({
    base: false,
    lg: true
  })

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false)
    }, 2500)
  }, [])

  if (isLoading) {
    return (
      <Box overflow="hidden" position="relative">
        <Header>
          <Flex
            mx="auto"
            w="100%"
            direction="row"
            display="flex"
            my="6"
            align="center"
            justify="space-around"
          >
            <Box mx="auto">
              <Text fontSize="24px" fontWeight="600" height="100%">
                {t('title')}
              </Text>
            </Box>
          </Flex>
        </Header>
        <Sidebar />
        <Flex
          flex="1"
          mx="auto"
          as="form"
          ml={isWideVersion ? '75px' : '2'}
          mt="15px"
          mb="8px"
          mr="2"
          bg="white"
          h="cal(100vh - 60px)"
        >
          <Flex w="100%" h="100vh" flex="1" align="center" justify="center">
            <Spinner color="blue" />
          </Flex>
        </Flex>
      </Box>
    )
  }

  return (
    <Box overflow="hidden" position="relative">
      <Header>
        <Flex
          mx="auto"
          w="100%"
          direction="row"
          display="flex"
          my="6"
          align="center"
          justify="space-around"
        >
          <Box mx="auto">
            <Text fontSize="24px" fontWeight="600" height="100%">
              {t('title')}
            </Text>
          </Box>
        </Flex>
      </Header>
      <Sidebar />

      <Flex
        flex="1"
        mx="auto"
        as="form"
        ml={isWideVersion ? '75px' : '2'}
        mt="15px"
        mb="8px"
        mr="2"
        bg="white"
        h="cal(100vh - 60px)"
      >
        <Stack spacing="4" w="100%">
          <CardContainer title={t('containerOne.title')}>
            <WhatsappConnect />
          </CardContainer>
          <Flex w="100%" h="200px" />
        </Stack>
      </Flex>
    </Box>
  )
}
